import {
  Box,
  Container,
  Divider,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material'
import React from 'react'
import styles from './about.module.scss'
import MapChip from './MapChip'

const CompanyInfoTablePC: React.FC = () => (
  <Container maxWidth="md">
    <TableContainer>
      <Divider />
      <Table aria-label="simple table">
        <TableBody>
          {/* 社名 */}
          <TableRow className={styles.table_row}>
            <TableCell component="th" scope="row">
              <Typography variant="body1">社名</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body1">AGキャピタル株式会社 (AG Capital Co.,Ltd)</Typography>
            </TableCell>
          </TableRow>

          {/* 所在地 */}
          <TableRow className={styles.table_row}>
            <TableCell sx={{ verticalAlign: 'baseline', paddingTop: '24px' }} component="th" scope="row">
              <Typography variant="body1">所在地</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body1">〒104-0061</Typography>
              <Box display="flex">
                <Typography alignItems="center" variant="body1">
                  東京都中央区銀座一丁目６番２号 LIFE CARD 銀座ビル
                  {/* map button */}
                  <MapChip />
                </Typography>
              </Box>
            </TableCell>
          </TableRow>

          {/* 設立 */}
          <TableRow className={styles.table_row}>
            <TableCell component="th" scope="row">
              <Typography variant="body1">設立</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body1">1985年(昭和60年)12月12日</Typography>
            </TableCell>
          </TableRow>

          {/* 連絡先 */}
          <TableRow className={styles.table_row}>
            <TableCell sx={{ verticalAlign: 'baseline', paddingTop: '24px' }} component="th" scope="row">
              <Typography variant="body1">連絡先</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body1">
                TEL: 03-4503-6400(代表)
                <br />
                メール: info@agcapital.jp
              </Typography>
            </TableCell>
          </TableRow>

          {/* 資本金 */}
          <TableRow className={styles.table_row}>
            <TableCell sx={{ verticalAlign: 'baseline', paddingTop: '24px' }} component="th" scope="row">
              <Typography variant="body1">資本金</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body1">
                10百万円(授権株式数228千株)
                <br />
                発行済株式数57千株
              </Typography>
            </TableCell>
          </TableRow>

          {/* 株主 */}
          <TableRow className={styles.table_row}>
            <TableCell component="th" scope="row">
              <Typography variant="body1">株主</Typography>
            </TableCell>
            <TableCell>
              <Link variant="body1" href="https://www.aiful.co.jp/" target="blank" color="inherit">
                アイフル株式会社
              </Link>
            </TableCell>
          </TableRow>

          {/* 代表取締役 */}
          <TableRow className={styles.table_row}>
            <TableCell component="th" scope="row">
              <Typography variant="body1">代表取締役</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body1">代表取締役社長 深田裕司</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    <Typography pl={1} pt="23px" variant="body1" color="#686868">
      ※ 名刺に記載の連絡先、会社名、事業内容などの情報は、アイフル株式会社及びそのグループ会社と共有します。
    </Typography>
  </Container>
)

export default CompanyInfoTablePC
